// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

//Components
import WithRender from "Components/Search/PagesSearchCard/pages-search-card.html";
import page from "Components/Search/PagesSearchCard/PageContentTypes/Page/page";
import newsarticle from "Components/Search/PagesSearchCard/PageContentTypes/News/newsarticle";
import literature from "Components/Search/PagesSearchCard/PageContentTypes/Literature/literature";


@WithRender
@Component({
	components: {
		page,
		newsarticle,
		literature
	}
})

export default class PagesSearchCard extends Vue {
	@Prop({}) title: string;
	@Prop({}) url: string;
	@Prop({}) highlightResults: any;
	@Prop({}) contentType: string;
	@Prop({}) imageUrl: string;
	@Prop({}) contentTypeDisplay: string;
}
